import React from "react";

function TruckHeavy() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45.486"
      height="16.85"
      viewBox="0 0 45.486 16.85"
    >
      <g transform="translate(.325 .325)">
        <path
          d="M380.462 33.32v-5.335a.4.4 0 01.4-.4h7.043"
          className="cls-1"
          transform="translate(-358.907 -27.58)"
        ></path>
        <path
          d="M357.007 55.355a3.027 3.027 0 01-5.7-1.412"
          className="cls-1"
          transform="translate(-344.319 -40.77)"
        ></path>
        <path
          d="M362.019 53.943a3.026 3.026 0 003.026 3.027h1.164"
          className="cls-1"
          transform="translate(-349.68 -40.77)"
        ></path>
        <path
          d="M400.609 55.355a3.027 3.027 0 01-5.7-1.412"
          className="cls-1"
          transform="translate(-366.133 -40.77)"
        ></path>
        <path
          d="M409.811 56.97h-1.164a3.027 3.027 0 01-3.027-3.027"
          className="cls-1"
          transform="translate(-371.494 -40.77)"
        ></path>
        <path
          d="M401.424 40.753h-6.053V27.58h6.611a1.165 1.165 0 011.1.8l1.6 5.291h4.424a1.164 1.164 0 011.164 1.164v4.06"
          className="cls-1"
          transform="translate(-366.366 -27.58)"
        ></path>
        <path
          d="M0 0h18.761"
          className="cls-1"
          transform="translate(10.244 5.736)"
        ></path>
        <path
          d="M9.449 0H0"
          className="cls-1"
          transform="translate(19.556 13.174)"
        ></path>
        <path
          d="M339.192 44.638V39.77a.7.7 0 01.7-.7h8.61v1.779"
          className="cls-1"
          transform="translate(-338.26 -33.327)"
        ></path>
        <path
          d="M357.828 46.4v1.906"
          className="cls-2"
          transform="translate(-347.583 -36.997)"
        ></path>
        <path
          d="M348.5 53.944h-9.31"
          className="cls-1"
          transform="translate(-338.259 -40.77)"
        ></path>
        <path
          d="M397.7 29.208a.233.233 0 01.232-.232h4.783a.921.921 0 01.9.529l1.352 4.554a.233.233 0 01-.147.294.245.245 0 01-.073.011h-6.817a.233.233 0 01-.232-.232z"
          className="cls-1"
          transform="translate(-367.532 -28.277)"
        ></path>
        <rect
          width="12.106"
          height="1.862"
          className="cls-1"
          rx="0.931"
          transform="translate(0 11.311)"
        ></rect>
        <path
          d="M420.224 50.216h2.822a.51.51 0 01.51.51v.842a.51.51 0 01-.51.51h-2.982"
          className="cls-1"
          transform="translate(-378.72 -38.905)"
        ></path>
        <path
          fill="none"
          stroke="#2a2e43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.284"
          d="M29.936 7.286h2.328a.7.7 0 01-.7.7h-.931a.7.7 0 01-.7-.7z"
          style={{ isolation: "isolate" }}
          opacity="0.2"
        ></path>
        <path
          d="M397.234 42.16h2.328a.466.466 0 01-.466.466h-1.4a.466.466 0 01-.466-.466z"
          className="cls-2"
          transform="translate(-367.298 -34.874)"
        ></path>
        <path
          fill="none"
          stroke="#2a2e43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.284"
          d="M4.656 7.751h1.862a.7.7 0 01-.7.7h-.466a.7.7 0 01-.7-.7z"
          style={{ isolation: "isolate" }}
          opacity="0.1"
        ></path>
        <path
          d="M346.644 43.092h1.862a.466.466 0 01-.466.466h-.931a.466.466 0 01-.466-.466z"
          className="cls-2"
          transform="translate(-341.988 -35.341)"
        ></path>
        <path
          d="M414.469 50.447a3.492 3.492 0 00-6.985 0"
          className="cls-1"
          transform="translate(-372.426 -37.273)"
        ></path>
        <circle
          cx="3.026"
          cy="3.026"
          r="3.026"
          className="cls-1"
          transform="translate(35.291 10.147)"
        ></circle>
        <circle
          cx="1.513"
          cy="1.513"
          r="1.513"
          className="cls-5"
          transform="translate(36.804 11.661)"
        ></circle>
        <path
          d="M369.063 50.447a3.492 3.492 0 00-6.984 0h-1.8"
          className="cls-1"
          transform="translate(-348.808 -37.273)"
        ></path>
        <circle
          cx="3.026"
          cy="3.026"
          r="3.026"
          className="cls-1"
          transform="translate(13.503 10.147)"
        ></circle>
        <circle
          cx="1.513"
          cy="1.513"
          r="1.513"
          className="cls-5"
          transform="translate(15.016 11.661)"
        ></circle>
        <path
          d="M355.961 44.123v.364h-1.352a.51.51 0 01-.51-.51v-.842a.51.51 0 01.51-.51h1.352v.218"
          className="cls-2"
          transform="translate(-345.718 -35.107)"
        ></path>
        <path
          d="M357.826 42.8v-.18a.466.466 0 01.466.466v.931a.466.466 0 01-.466.466v-.214"
          className="cls-2"
          transform="translate(-347.582 -35.107)"
        ></path>
        <path
          d="M339.19 42.625h1.352a.51.51 0 01.51.51v.842a.51.51 0 01-.51.51h-1.352v-1.862z"
          className="cls-2"
          transform="translate(-338.259 -35.107)"
        ></path>
        <path
          d="M383.724 33.711v-4.738a.233.233 0 01.466 0v4.564"
          className="cls-6"
          transform="translate(-360.539 -28.161)"
        ></path>
        <path
          d="M387.451 33.276v-4.3a.233.233 0 01.466 0V33.7"
          className="cls-6"
          transform="translate(-362.404 -28.161)"
        ></path>
        <path
          d="M391.178 33.844v-4.871a.233.233 0 01.466 0v4.587"
          className="cls-6"
          transform="translate(-364.268 -28.161)"
        ></path>
      </g>
    </svg>
  );
}

export default TruckHeavy;
